import ManageMySpending from "../ManageMySpending";
import {
  Button1,
  Button2,
  Checkbox,
  MultiColorBar,
  ProgressBar,
  Select,
  SmallCircle,
} from "../../index";
import plusIcon from "../../../assets/icons/plus.png";
import { DatePicker } from "antd";
import calendarIcon from "../../../assets/icons/calendar-icon.png";
import circleIcon from "../../../assets/icons/Ellipse 81.png";
import { useBudgets } from "../../../data/live";
import QuickActionSelect from "../../quick-action-select/QuickActionSelect";

const BudgetTracker = () => {
  const { items: budgets, source } = useBudgets();

  const budgetReport = budgets.length > 0 ? budgets.map(b => ({
    label: b.category,
    color: "#1bbb6b", // default color
    received: `${Number(b.spent).toLocaleString()} ${b.currency}`,
    budget: `${Number(b.limit).toLocaleString()} ${b.currency}`,
    remaining: `${(Number(b.limit) - Number(b.spent)).toLocaleString()} ${b.currency}`,
    percent: Math.min(Math.round((Number(b.spent) / Number(b.limit)) * 100), 100),
  })) : [
    {
      label: "Income",
      color: "#1bbb6b",
      received: "$4,000",
      budget: "$3,000 (0 days left)",
      remaining: "$1,000",
      percent: 68,
    },
    {
      label: "Essentials",
      color: "#F7A64F",
      received: "$3,000",
      budget: "$2,500 (0 days left)",
      remaining: "$500",
      percent: 50,
    },
    {
      label: "Lifestyle",
      color: "#FC555B",
      received: "$1,000",
      budget: "$1,100 (0 days left)",
      remaining: "$100",
      percent: 50,
    },
  ];

  const monthlyReviewReport = [
    {
      name: "Income",
      color: "#1bbb6b",
      amount: "10,500 AUD",
    },
    {
      name: "Essentials",
      color: "#F7A64F",
      amount: "6,449 AUD",
    },
    {
      name: "Lifestyles",
      color: "#FC555B",
      amount: "1,041 AUD",
    },
    {
      name: "Saving",
      color: "#E3E3E3",
      amount: "0 AUD",
    },
  ];

  const bankAccountsDetails = [
    {
      icon: circleIcon,
      name: "Personal Account",
    },
    {
      icon: circleIcon,
      name: "Saving Account",
    },
    {
      icon: circleIcon,
      name: "Standard Checking",
    },
    {
      icon: circleIcon,
      name: "Transactional Account",
    },
  ];

  const creditCardDetails = [
    {
      icon: circleIcon,
      name: "American Express Platinum Edge",
    },
  ];

  const loansDetails = [
    {
      icon: circleIcon,
      name: "Personal loans",
    },
  ];
  const investmentDetails = [
    {
      icon: circleIcon,
      name: "AMP Flexible Super - Super Account",
    },
    {
      icon: circleIcon,
      name: "ANZ Account",
    },
  ];
  return (
    <>
      <ManageMySpending navName={"Manage My Spending"}>
        <div className="row mt-3 ">
          <div className="d-flex justify-content-md-between align-items-center justify-content-center flex-wrap flex-md-nowrap gap-2 gap-md-0">
            <div className="d-flex align-items-center gap-2">
              <span className="fs-5 fw-semibold">Budget Tracking</span>
              {source === "api" && (
                <span className="badge rounded-pill bg-success-subtle text-success border border-success-subtle fs10px">
                  LIVE
                </span>
              )}
            </div>
            <div className="d-flex gap-2 align-items-center flex-wrap justify-content-md-end justify-content-center">
              <Select
                className="rounded-pill w-auto"
                options={[
                  { name: "Last 90 days", value: "90" },
                  { name: "Last 60 days", value: "60" },
                  { name: "Last 30 days", value: "30" },
                ]}
              />

              <Button2
                buttonName={"Create a Budget"}
                icon={<img src={plusIcon} alt="add" />}
                divClassName={"gap-2"}
                className={"btn-outline-success w-auto"}
              />

              <QuickActionSelect />
            </div>
          </div>

          <div className="col-lg-8 mt-3">
            <div className="d-flex flex-column gap-3 border rounded-3">
              <div className="d-flex justify-content-between align-items-center p-3 px-4 border-bottom">
                <span className="fs-5 fw-semibold">Budget</span>
                <div className="d-flex gap-2 alig-items-center">
                  <DatePicker
                    className="rounded-pill w-auto"
                    placeholder="Date from "
                    suffixIcon={<img src={calendarIcon} alt="icon" />}
                  />
                  <DatePicker
                    className="rounded-pill w-auto"
                    placeholder="Date to "
                    suffixIcon={<img src={calendarIcon} alt="icon" />}
                  />
                </div>
              </div>

              <div className="d-flex flex-column">
                {budgetReport.map(
                  ({ label, color, received, remaining, percent, budget }) => (
                    <div className="d-flex flex-column gap-2 p-3 px-4">
                      <ProgressBar
                        label={label}
                        labelClassName="fs-6 fw-semibold"
                        strokeColor={color}
                        strokeWidth={"18px"}
                        percent={percent}
                      />
                      <div
                        className="d-flex justify-content-between align-items-center "
                        style={{ width: "88%" }}
                      >
                        {/* Recieved */}
                        <span
                          className="fs12px fw-medium"
                          style={{ color: "#7D7D7D" }}
                        >
                          Received:{" "}
                          <span className="fw-bold" style={{ color: color }}>
                            {received}
                          </span>
                        </span>

                        {/* Budget */}
                        <span
                          className="fs12px fw-medium"
                          style={{ color: "#7D7D7D" }}
                        >
                          Budget:{" "}
                          <span className="fw-bold" style={{ color: color }}>
                            {budget}
                          </span>
                        </span>

                        {/* Remaining */}
                        <span
                          className="fs12px fw-medium"
                          style={{ color: "#7D7D7D" }}
                        >
                          Remaining:{" "}
                          <span className="fw-bold" style={{ color: color }}>
                            {remaining}
                          </span>
                        </span>
                      </div>
                    </div>
                  )
                )}
              </div>

              <div className="d-flex justify-content-between align-items-center p-3 px-4">
                <div className="d-flex flex-column gap-1">
                  <span className="fs-5 fw-semibold">Surplus/Deficit</span>
                  <span
                    className="fs12px fw-medium"
                    style={{ color: "#7D7D7D" }}
                  >
                    Target:{" "}
                    <span className="fw-bold" style={{ color: "#1bbb6b" }}>
                      $2,164 (0 days left)
                    </span>
                  </span>
                </div>

                <span
                  className="fs-3 fw-semibold align-self-start"
                  style={{ color: "#1bbb6b" }}
                >
                  314 AUD
                </span>
              </div>
            </div>
          </div>

          <div className="col-lg-4 mt-3">
            <div className="d-flex flex-column gap-2  border rounded-3">
              <div className="d-flex flex-column gap-3  p-3">
                <span className="fs-5 fw-semibold">Monthly Review</span>

                <ProgressBar
                  label={"Income"}
                  labelClassName="fw-semibold"
                  percent={100}
                  strokeColor="#1bbb6b"
                  strokeWidth={"14px"}
                />

                <MultiColorBar
                  height="14px"
                  label={"Saving"}
                  labelClassName={"fw-semibold"}
                  colors={["#F7A64F", "#FC555B", "#E3E3E3"]}
                />
                <div className="d-flex flex-column gap-3 border-bottom pb-3">
                  {monthlyReviewReport.map(({ name, color, amount }) => (
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-2 align-items-center">
                        <SmallCircle color={color} />
                        <span className="fs12px fw-semibold">{name}</span>
                      </div>
                      <span
                        className="fs12px fw-bold"
                        style={{
                          color: `${name === "Income" ? "#1bbb6b" : "#FC555B"}`,
                        }}
                      >
                        {amount}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="d-flex flex-column gap-2 p-3 border-bottom">
                <div className="d-flex justify-content-between align-items-center">
                  <span
                    className="fs14px fw-medium"
                    style={{ color: "#7D7D7D" }}
                  >
                    Surplus
                  </span>
                  <span className="fs14px fw-semibold">3,009 AUD</span>
                </div>
                <Button1
                  buttonName={"Edit Budget"}
                  className={"btn-outline-success"}
                />
              </div>

              <div className="d-flex flex-column p-3">
                <div className="d-flex justify-content-between align-items-center p-3">
                  <span className="fs-5 fw-semibold">Filter</span>
                  <span
                    className="fw-medium fs14px cursor-pointer"
                    style={{ color: "#1bbb6b" }}
                  >
                    Reset
                  </span>
                </div>

                {/* Category */}
                <div className="d-flex justify-content-between align-items-center border-bottom p-3">
                  <span className="fw-medium">Categories</span>
                  <div className="d-flex gap-2 align-items-center">
                    <span className="fs14px" style={{ color: "#7D7D7D" }}>
                      0 Selected
                    </span>
                    <img
                      src={plusIcon}
                      alt="add"
                      className="cursor-pointer"
                      width={18}
                      height={18}
                    />
                  </div>
                </div>

                {/* Tags */}
                <div className="d-flex justify-content-between align-items-center border-bottom p-3">
                  <span className="fw-medium">Tags</span>
                  <div className="d-flex gap-2 align-items-center">
                    <span className="fs14px" style={{ color: "#7D7D7D" }}>
                      0 Selected
                    </span>
                    <img
                      src={plusIcon}
                      alt="add"
                      className="cursor-pointer"
                      width={18}
                      height={18}
                    />
                  </div>
                </div>

                {/* Accounts */}
                <div className="d-flex flex-column gap-2 p-3 ">
                  <div className="d-flex justify-content-between align-items-center ">
                    <span className="fw-medium">Accounts</span>
                    <div className="d-flex gap-2 align-items-center">
                      <span className="fs14px" style={{ color: "#7D7D7D" }}>
                        7 Selected
                      </span>
                      <img
                        src={plusIcon}
                        alt="add"
                        className="cursor-pointer"
                        width={18}
                        height={18}
                      />
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <span className="fs14px" style={{ color: "#7d7d7d" }}>
                      Bank Accounts
                    </span>
                    {bankAccountsDetails.map(({ name, icon }, key) => (
                      <div
                        key={key}
                        className="d-flex gap-2 align-items-center"
                      >
                        <Checkbox />
                        <img src={icon} width={20} height={20} alt="icon" />
                        <span className="fs12px fw-medium">{name}</span>
                      </div>
                    ))}
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <span className="fs14px" style={{ color: "#7d7d7d" }}>
                      Credit Card
                    </span>
                    {creditCardDetails.map(({ name, icon }, key) => (
                      <div
                        key={key}
                        className="d-flex gap-2 align-items-center"
                      >
                        <Checkbox />
                        <img src={icon} width={20} height={20} alt="icon" />
                        <span className="fs12px fw-medium">{name}</span>
                      </div>
                    ))}
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <span className="fs14px" style={{ color: "#7d7d7d" }}>
                      Loans
                    </span>
                    {loansDetails.map(({ name, icon }, key) => (
                      <div
                        key={key}
                        className="d-flex gap-2 align-items-center"
                      >
                        <Checkbox />
                        <img src={icon} width={20} height={20} alt="icon" />
                        <span className="fs12px fw-medium">{name}</span>
                      </div>
                    ))}
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <span className="fs14px" style={{ color: "#7d7d7d" }}>
                      Investment
                    </span>
                    {investmentDetails.map(({ name, icon }, key) => (
                      <div
                        key={key}
                        className="d-flex gap-2 align-items-center"
                      >
                        <Checkbox />
                        <img src={icon} width={20} height={20} alt="icon" />
                        <span className="fs12px fw-medium">{name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <Button1
                buttonName={"View Transaction"}
                className={"btn-outline-success m-3"}
              />
            </div>
          </div>
        </div>
      </ManageMySpending>
    </>
  );
};

export default BudgetTracker;
